import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router  } from '@angular/router';

//  Jquery imports
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  @ViewChild('linkRecv') received: ElementRef;
  @ViewChild('linkArch') archived: ElementRef;
  @ViewChild('linkPend') pending: ElementRef;
  public show_search: boolean;
  public items = [{ 'name': 'archie' }, { 'name': 'jake' }, { 'name': 'richard' }];

  constructor(private route: ActivatedRoute, private router: Router) {
   }

  ngOnInit() {

  }

  onSearch(data: string) {
    if (data === 'test') {
      this.show_search = true;
    }else {
      this.show_search = false;
    }
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/chat/menu/menu.component.ts